import { Injectable } from '@angular/core';
import { Store } from '../../../services/store';
import { Observable, of, tap } from 'rxjs';
import { OrdersBoardProvider } from './orders-board.provider';
import { Order } from '../orders-new/models/order.dto';
import { toVoid } from '../../../utils/void';
import { OrderBoard } from './models/order.view-model';

export interface OrdersBoardState {
  loading: boolean;
  // orders: Order[] | undefined;
  board: OrderBoard | undefined;
}

const INITIAL_STATE: OrdersBoardState = {
  loading: false,
  // orders: undefined,
  board: undefined
};

@Injectable({ providedIn: 'root' })
export class OrdersBoardStore extends Store<OrdersBoardState> {
  constructor(private provider: OrdersBoardProvider) {
    super(INITIAL_STATE);
  }

  // loading means no board yet (0127): the page destroys the store when it leaves, so init() never
  // runs over a board the page already shows
  init(): Observable<void> {
    this.update(state => ({ ...state, loading: true }));

    return this.provider.getOrders()
      .pipe(
        tap(orders => {
          this.update(state => ({
            ...state,
            loading: false,
            board: OrderBoard.mapModelToViewModel(orders)
          }));
        }),
        toVoid()
      );
  }
}
